import apiClient from '../../../Services/ApiClient';
import { META_QUERY } from '../../Meta/Graphql/meta.query';
// @ts-ignore
import moment from 'moment';

interface WorkplaceWorkingHoursArgs {
	workplaceId?: string;
	extra?: boolean;
}

export const workplaceWorkingHours = async (
	args: WorkplaceWorkingHoursArgs,
) => {
	const { workplaceId, extra = false } = args;

	const workingHours = await apiClient.graphql({
		query: META_QUERY,
		variables: {
			key: 'workingHours' + (extra ? 'Extra' : ''),
			workplaceId: workplaceId,
		},
		fetchPolicy: 'network-only',
	});

	const schedule = workingHours?.data?.meta?.value;
	const dayToIndex = {
		mon: 1,
		tue: 2,
		wed: 3,
		thu: 4,
		fri: 5,
		sat: 6,
		sun: 0,
	};

	const workingHoursResult = [];

	for (const dayName in schedule) {
		const dayValues = schedule[dayName];

		if (dayValues && dayValues?.length > 0) {
			let start;
			let end;

			for (const dayValue of dayValues) {
				const timeFrom = moment('2022-08-17T' + dayValue.timeFrom).format(
					'HH:mm',
				);
				const timeTo = moment('2022-08-17T' + dayValue.timeTo).format('HH:mm');

				// if (!start || start && Number(start.split(':')[0]) > Number(timeFrom.split(':')[0])) {
				//     start = timeFrom;
				// }
				//
				// if (!end || end && Number(end.split(':')[0]) < Number(timeTo.split(':')[0])) {
				//     end = timeTo;
				// }

				workingHoursResult.push({
					daysOfWeek: [dayToIndex[dayName]],
					startTime: timeFrom,
					endTime: timeTo,
				});
			}

			// if (start && end) {
			//     workingHoursResult.push({
			//         daysOfWeek: [dayToIndex[dayName]],
			//         startTime: start,
			//         endTime: end
			//     })
			// }
		}
	}

	return workingHoursResult;
};
